const firebaseConfig = {
  apiKey: "AIzaSyDTHCjNRNiiv7zA9LEQ8tGQJ50locahoJ4",
  authDomain: "go-green-recycling.firebaseapp.com",
  projectId: "go-green-recycling",
  storageBucket: "go-green-recycling.appspot.com",
  messagingSenderId: "53214389597",
  appId: "1:53214389597:web:dac764741561935133f4b4"
  };
   
  export default firebaseConfig;